export var CircleActionType;
(function (CircleActionType) {
    CircleActionType["ADD_CIRCLE"] = "ADD_CIRCLE";
    CircleActionType["DELETE_CIRCLE"] = "DELETE_CIRCLE";
    CircleActionType["UPDATE_CIRCLE"] = "UPDATE_CIRCLE";
    CircleActionType["ADD_LIST_CIRCLE"] = "ADD_LIST_CIRCLE";
    CircleActionType["CLEAR_ALL_CIRCLES"] = "CLEAR_ALL_CIRCLES";
    CircleActionType["OPEN_CIRCLE_SETTINGS"] = "OPEN_CIRCLE_SETTINGS";
    CircleActionType["CLOSE_CIRCLE_SETTINGS"] = "CLOSE_CIRCLE_SETTINGS";
    CircleActionType["ADD_FOLLOWING_USER"] = "ADD_FOLLOWING_USER";
    CircleActionType["DELETE_FOLLOWING_USER"] = "DELETE_FOLLOWING_USER";
    CircleActionType["UPDATE_USER_TIE"] = "UPDATE_USER_TIE";
    CircleActionType["ADD_USER_TIE_LIST"] = "ADD_USER_TIE_LIST";
    CircleActionType["ADD_USER_TIED_LIST"] = "ADD_USER_TIED_LIST";
    CircleActionType["DELETE_USER_FROM_CIRCLE"] = "DELETE_USER_FROM_CIRCLE";
    CircleActionType["SHOW_SELECT_CIRCLE_BOX"] = "SHOW_SELECT_CIRCLE_BOX";
    CircleActionType["HIDE_SELECT_CIRCLE_BOX"] = "HIDE_SELECT_CIRCLE_BOX";
    CircleActionType["SET_SELECTED_CIRCLES_USER_BOX_COMPONENT"] = "SET_SELECTED_CIRCLES_USER_BOX_COMPONENT";
    CircleActionType["REMOVE_SELECTED_CIRCLES_USER_BOX_COMPONENT"] = "REMOVE_SELECTED_CIRCLES_USER_BOX_COMPONENT";
    CircleActionType["OPEN_SELECT_CIRCLES_USER_BOX_COMPONENT"] = "OPEN_SELECT_CIRCLES_USER_BOX_COMPONENT";
    CircleActionType["CLOSE_SELECT_CIRCLES_USER_BOX_COMPONENT"] = "CLOSE_SELECT_CIRCLES_USER_BOX_COMPONENT";
    CircleActionType["SHOW_FOLLOWING_USER_LOADING"] = "SHOW_FOLLOWING_USER_LOADING";
    CircleActionType["HIDE_FOLLOWING_USER_LOADING"] = "HIDE_FOLLOWING_USER_LOADING";
})(CircleActionType || (CircleActionType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/circleActionType.ts
// module id = 291
// module chunks = 50